const { documentReady, windowLoaded } = require('@grpn/document-states');
const { initGtm } = require('src/frontend/helper/general/m_googleTagManager');
const backToTopButton = require('modules/gig_body/components/back2top/frontend/main');
const doubleClick = require('modules/doubleclick/frontend/doubleclick');
const {
  checkRightToForget,
} = require('modules/right_to_forget_gdpr/frontend/rightToForgetGdpr');
const {
  initGdprCookieBanners,
} = require('modules/cookie_banner_gdpr/frontend/main');

const {
  loadSocialModal,
} = require('modules/subscription_service/frontend/socialModal');
const { checkDoNotSell } = require('modules/do_not_sell/frontend/doNotSell');

const { loadBoldChat } = require('src/frontend/core/loadBoldChat');

require('grpn-gig-components/lib/components/a11y/a11y');

documentReady.then(() => {
  document.body.classList.remove('no-js');
});

windowLoaded.then(() => {
  initGdprCookieBanners();
  doubleClick.init();

  checkRightToForget();
  if (Cookie.get('c') && I18n.country === 'US') {
    checkDoNotSell();
  }

  Groupon.Utils.lazyLoadImages('.lazy-wl', { threshold: 200 });

  loadSocialModal(document.head.dataset.app);

  new backToTopButton();

  initGtm();
  if (window.Groupon.boldChat) {
    loadBoldChat(window.Groupon.boldChat);
  }
});

//Do not remove or hash on dynamic imports will not update
export default () => {};
